import React from "react";
import '../reachus.css'
const CalendlyComponent = () => {
  return (
    <div class="calendly-container">
    <h2>Book a Meeting</h2>
    <iframe src="https://calendly.com/215160-aack" frameborder="0"></iframe>
</div>
  );
};

export default CalendlyComponent;
